module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timenote-header"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('span', {
    staticClass: "timenote-header-day"
  }, [_vm._v("星期" + _vm._s(_vm.noteWeekday))]), _vm._v(" "), _c('span', {
    staticClass: "timenote-header-date"
  }, [_vm._v(" " + _vm._s(_vm.noteDate))])]), _vm._v(" "), _c('md-layout', [_c('md-button-toggle', {
    attrs: {
      "md-single": ""
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.chooseDate('yesterday')
      }
    }
  }, [_vm._v("\n            昨天\n          ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.chooseDate('today')
      }
    }
  }, [_vm._v("\n            今天\n          ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "date": _vm.noteChooseDate
    },
    on: {
      "change": _vm.dateChange
    }
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    style: ({
      margin: 0,
      padding: 0,
      minHeight: '40px'
    })
  }, [_vm._v("\n              自定义\n            ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent timenote-setting",
    nativeOn: {
      "click": function($event) {
        _vm.toggleRightSidenav($event)
      }
    }
  }, [_vm._v("\n      设置\n    ")])], 1), _vm._v(" "), _c('md-whiteframe', {
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "添加事件"
    },
    model: {
      value: (_vm.thingContentInputVal),
      callback: function($$v) {
        _vm.thingContentInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "thingContentInputVal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "use-time",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.isTimeInputErrorMsg
    }
  }, [_c('md-input', {
    attrs: {
      "type": "number",
      "placeholder": "用时（h）"
    },
    model: {
      value: (_vm.thingTimeInputVal),
      callback: function($$v) {
        _vm.thingTimeInputVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "thingTimeInputVal"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTimeInputErrorMsg),
      expression: "isTimeInputErrorMsg"
    }],
    staticClass: "md-error"
  }, [_vm._v("一天只有24小时哦！")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("标签")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "movie",
      "id": "movie"
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('md-option', {
      key: tag.id,
      attrs: {
        "value": tag.text
      }
    }, [_vm._v(_vm._s(tag.text))])
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("子标签")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "movie",
      "id": "movie",
      "disabled": _vm.childTags.length === 0
    },
    model: {
      value: (_vm.childTag),
      callback: function($$v) {
        _vm.childTag = $$v
      },
      expression: "childTag"
    }
  }, _vm._l((_vm.childTags), function(childTag) {
    return _c('md-option', {
      key: childTag.id,
      attrs: {
        "value": childTag.text
      }
    }, [_vm._v(_vm._s(childTag.text))])
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary add-btn",
    attrs: {
      "disabled": _vm.thingContentInputVal.length === 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.addTimenote($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.timenotes.length > 0),
      expression: "timenotes.length>0"
    }],
    staticClass: "timenote-group"
  }, [_c('md-table-card', [_c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("事件名称")]), _vm._v(" "), _c('md-table-head', [_vm._v("用时")]), _vm._v(" "), _c('md-table-head', [_vm._v("标签")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.timenotes), function(timenote) {
    return _c('md-table-row', {
      key: timenote.id
    }, [_c('md-table-cell', [_vm._v(_vm._s(timenote.text))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(timenote.time))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(timenote.tag) + " -- " + _vm._s(timenote.childTag))])], 1)
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.timenotes), function(timenote) {
    return _c('div', {
      key: timenote.id,
      staticClass: "timenote-item",
      on: {
        "mouseover": function($event) {
          _vm.selectedOne = timenote.id
        },
        "mouseout": function($event) {
          _vm.selectedOne = ''
        }
      }
    })
  })], 2), _vm._v(" "), _c('md-whiteframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.timenotes.length > 0),
      expression: "timenotes.length>0"
    }],
    staticClass: "timenote-chart",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('pie-chart', {
    attrs: {
      "option": _vm.chartOption
    }
  })], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right",
    on: {
      "open": function($event) {
        _vm.open('Right')
      },
      "close": function($event) {
        _vm.close('Right')
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Time Note 设置")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting-container"
  }, [_c('div', {
    staticClass: "setting-add-tag"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "添加标签,按回车确定"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTag($event)
      }
    },
    model: {
      value: (_vm.newTagVal),
      callback: function($$v) {
        _vm.newTagVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "newTagVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-tag-list"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('span', {
      key: tag.id,
      staticClass: "setting-tag-item",
      on: {
        "click": function($event) {
          _vm.chooseParentTag(tag)
        },
        "mouseover": function($event) {
          _vm.hoverTagOne = tag.id
        },
        "mouseout": function($event) {
          _vm.hoverTagOne = ''
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hoverTagOne === tag.id),
        expression: "hoverTagOne===tag.id"
      }],
      staticClass: "delete-tag",
      on: {
        "click": function($event) {
          _vm.removeTag(tag.id)
        }
      }
    }, [_vm._v("x")]), _vm._v("\n            " + _vm._s(tag.text) + "\n          ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-add-tag"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": '添加' + _vm.selectedParentTag.text + '子标签,按回车确定'
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addChildTag($event)
      }
    },
    model: {
      value: (_vm.newChildTagVal),
      callback: function($$v) {
        _vm.newChildTagVal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "newChildTagVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-tag-list"
  }, _vm._l((_vm.childTags), function(childTag) {
    return _c('span', {
      key: childTag.id,
      staticClass: "setting-tag-item",
      on: {
        "click": function($event) {
          _vm.removeChildTag(childTag.id)
        }
      }
    }, [_vm._v(_vm._s(childTag.text))])
  }))], 1)]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav($event)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2e6aa6dd"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/TimeNote.vue
// module id = 341
// module chunks = 1